import React from 'react'
import BlankPage from '../../components/blank_page'
import IntlMessages from '../../util/IntlMessages'
import Comeback from '../../components/comeback'
import * as constants from '../../constants'

export default function Financial() {
    return (
        <React.Fragment>
            <Comeback title={<IntlMessages id="financial" />} />
            <BlankPage type={constants.BLANK_PAGE_FINANCIAL} />
        </React.Fragment>
    )
}
